export default __webpack_public_path__ + "d2ebb8b71fd595f7854e1b8fef0ae370.png";